import { useCallback } from "react"
import useSWR from "swr"
import dayjs from "dayjs"
import { useNavigate } from "react-router-dom"
import { Search } from "lucide-react"
import { Input } from "../../components/ui/input"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table"
import { fetcher } from "../../util/axios"
import placeholder from "../../util/placeholder"
import PageSpinner from "../../components/PageSpinner"
import DataView from "../../components/DataView"
import { vehicleConfig } from "../../constants/data-view-configs/vehicle-list-config"
import { useCurrency } from "../../hooks/useCurrency"


export default function VehiclesPage() {
    const [formatCurrency] = useCurrency()
    const navigate = useNavigate();

    const { data, isLoading } = useSWR({ url: "fleet/vehicles" }, fetcher)
    const vehicles: Vehicle[] = data?.data.vehicles || [];

    const handleDataViewClick = useCallback((data: any) => {
        navigate(`/vehicles/${data.id}`)
    }, [navigate])

    if (isLoading){
        return<PageSpinner/>   
    }

    return (
        <div className="h-full overflow-auto border rounded-lg">
            <div className="p-4 border-b">
                <div className="relative w-full">
                    <Input type="text" placeholder="Search" className="w-full pl-4 pr-10 py-2 border rounded-md" />
                    <Search className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                </div>
            </div>
            {/* Vehicles Table for Medium & Large Screen */}
            <div className="hidden md:block">
                <Table>
                    <TableHeader>
                        <TableRow className="bg-white">
                            <TableHead className="font-semibold">Reference</TableHead>
                            <TableHead className="font-semibold">Category</TableHead>
                            <TableHead className="font-semibold">Status</TableHead>
                            <TableHead className="font-semibold">Date added</TableHead>
                            <TableHead className="font-semibold">Total Trips</TableHead>
                            <TableHead className="font-semibold">Total earned</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {vehicles?.map((vehicle) => (
                            <TableRow key={vehicle.id} className="border-t hover:bg-gray-50 cursor-pointer" onClick={() => navigate(`/vehicles/${vehicle.id}`)}>
                                <TableCell>{vehicle.regPlate}</TableCell>
                                <TableCell>
                                    <div className="w-10 h-10 border rounded flex items-center justify-center">
                                        <img
                                            src={ vehicle.truckCategoryDetails.image || placeholder}
                                                alt={"vehicle"}
                                            width={30}
                                            height={30}
                                            className="object-contain"
                                        />
                                    </div>
                                </TableCell>
                                <TableCell>
                                    <span className={`text-${vehicle?.status === "Active" ? "blue" : "orange"}-600`}>
                                        {vehicle?.status ?? "Active"}
                                    </span>
                                </TableCell>
                                <TableCell>{dayjs(vehicle.createdAt).format("DD/MM/YYYY")}</TableCell>
                                <TableCell>{vehicle.totalTrips}</TableCell>
                                <TableCell className="text-orange-500">{formatCurrency(+vehicle.totalEarned)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
            {/* Mobile Screen Cards */}
            <div className="md:hidden mt-4">
                <DataView
                    loading={isLoading}
                    records={vehicles}
                    config={vehicleConfig}
                    onClick={handleDataViewClick}
                />
            </div>            
        </div>
    )
}

